// Текст для человека, когда сохранение не прошло.
//
// Сетевой обрыв — отдельный случай: ответ мог потеряться уже после того, как
// сервер всё записал (iOS-PWA), а повтор безопасен — у записей есть client_id,
// и сервер на него отдаёт уже созданное. Поэтому здесь не «ошибка», а
// спокойное «осталось на экране»: окно само повторит отправку, когда связь
// вернётся (services/netStatus.js, registerPendingSave), и нажать ещё раз
// тоже можно.
export function describeSaveError(err) {
  if (!err?.response) {
    return 'Нет связи. Всё введённое осталось на экране — отправлю само, как только связь появится. Можно нажать и ещё раз, дубля не будет.'
  }
  const detail = err.response?.data?.detail ? ` (${err.response.data.detail})` : ''
  return (err.response?.data?.error || 'Ошибка добавления') + detail
}

// Отказ без ответа сервера: обрыв, таймаут, нет сети
export function isNetworkFailure(err) {
  return !!err && !err.response
}
